import { Badge, UnstyledButton } from '@mantine/core';
import type { EntityType } from '../../domain/labels.js';
import { SYNC_STATUS, type SyncStatus } from '../../domain/status.js';
import { glyphIcon } from '../StatusBadge/glyphs.js';
import { cellTargets } from './cellTargets.js';
import type { MatrixColumn, OpenTarget } from './types.js';

/**
 * One pill per environment column: the registry's own name, coloured by the row's status there,
 * opening the drawer on the row in that environment — the phone's answer to a column. Wrap in a
 * wrapping `Group` at the call site.
 *
 * `tt="none"` and monospace are not decoration: the environment name is a string someone
 * correlates with ArgoCD and `kubectl`, and Mantine would otherwise uppercase it into one that
 * does not exist.
 */
export const EnvPills = ({
    columns,
    cells,
    type,
    entityKey,
    name,
    onOpen,
}: {
    columns: MatrixColumn[];
    cells: Record<string, { status: SyncStatus } | undefined>;
    type: EntityType;
    entityKey: string;
    /** The row's display name, for the pill's label. */
    name: string;
    onOpen: (target: OpenTarget) => void;
}) => (
    <>
        {cellTargets(columns, cells, type, entityKey, name).map((cell) => {
            const meta = SYNC_STATUS[cell.status];
            const Icon = glyphIcon(meta.glyph);
            return (
                <UnstyledButton key={cell.environment} onClick={() => onOpen(cell.target)} aria-label={cell.label}>
                    <Badge
                        size="sm"
                        radius="sm"
                        variant="light"
                        tt="none"
                        className="rgs-numeric"
                        color={meta.color}
                        style={meta.dimmed ? { opacity: 0.65 } : undefined}
                        leftSection={<Icon size={12} />}
                    >
                        {cell.environment}
                    </Badge>
                </UnstyledButton>
            );
        })}
    </>
);
